import { useRobotContext } from './RobotContext';
export function useRobotController() {
    const { setState, currentState, mode } = useRobotContext();
    if (mode !== 'inline') {
        console.warn('useRobotController is primarily for inline mode. Bottom-bar mode is automatic.');
    }
    return {
        currentState,
        initialize: () => setState('welcome'),
        setStanding: () => setState('standing'),
        setThinking: () => setState('thinking'),
        startTyping: () => setState('typing-start'),
        stopTyping: () => setState('standing'),
        startListening: () => setState('listening-start'),
        stopListening: () => setState('listening-end'),
        startSpeaking: () => setState('speaking-start'),
        stopSpeaking: () => setState('speaking-end'),
    };
}
